<template>
  <div class="bg-gradient-info main">
    <div class="p-5">
      <h1 class="text-dark text-center">Ooops!</h1>
      <h2 class="text-center">404</h2>
      <p class="text-lead text-center">
        Page not found. Don't worry though, we have plenty of other pages to
        explore
      </p>
      <div class="text-center">
        <router-link to="/" class="font-weight-bold mt-5"
          >Return to start</router-link
        >
      </div>
    </div>
    <div class="separator separator-bottom separator-skew zindex-100">
      <svg
        x="0"
        y="0"
        viewBox="0 0 2560 100"
        preserveAspectRatio="none"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
      </svg>
    </div>
  </div>
</template>

<script>

export default {
  name: "not-found",
};
</script>

<style scoped lang="scss">
.main {
  height: 100vh;
}
</style>